import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../../components/Button'
import Field from '../../../../../../components/Form/Field'

import { CLICK_THROUGH_LINK } from '../../../fields'

import useStyles from '../../../../../../styles/common/stepForms'

const stepFields = [CLICK_THROUGH_LINK]

function LinkStep({ formik, handleStepChange }) {
  const { t } = useTranslation()
  const classes = useStyles()

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <>
      <div className={classes.stepTitle}>{t('Please provide a click through link')}</div>
      <div className={classes.stepBody}>
        <Field formik={formik} name={CLICK_THROUGH_LINK} placeholder={t('Click Through Link')} autoComplete="off" />
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

LinkStep.propTypes = {
  handleStepChange: PropTypes.func
}

export default LinkStep
